var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteFormBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 885,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E5ECC",
    d: "M0 0h495v885H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M495 575.999v180.002L366.001 885h-33.996l-28.657-28.663L493.686 666 303.348 475.652 349.001 430 495 575.999z",
    fill: "#fff",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.542 574.686l-28.091 28.1 126.427 126.428-98.336 98.329L113 666.001l35.113-35.124 126.429 126.429 28.1-28.092-126.428-126.428 98.328-98.337 161.551 161.552-35.123 35.113-126.428-126.428z",
    fill: "#fff",
    fillOpacity: 0.15
  })));
}

export default SvgQuoteFormBg;